import { useAdminOrganizationAuditQuery } from '@/client/api/admin/organizations';
import DataTable from '@/client/pages/Admin/UsersAndPermissions/UserDetailPage/components/DataTable';

const fmtDate = (v?: string | null) => (v ? new Date(v).toLocaleString() : '—');

const clean = (v?: string | null) => {
  const s = (v ?? '').trim();
  return s && s.toLowerCase() !== 'unknown' ? s : '';
};

const AuditTab = ({ oid }: { oid: number }) => {
  const { data, isLoading } = useAdminOrganizationAuditQuery(oid);
  const actions = data?.actions ?? [];

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-500">
        Audit trail for this organization from{' '}
        <code className="rounded bg-gray-100 px-1 py-0.5 text-xs">
          GET /api/admin/organizations/{oid}/audit
        </code>
        .
      </p>

      <DataTable
        loading={isLoading}
        rows={actions}
        keyFn={a => `${a.timestamp}-${a.action}-${a.target_id}`}
        emptyLabel="No audit entries."
        columns={[
          { header: 'When', cell: a => fmtDate(a.timestamp) },
          { header: 'Action', cell: a => a.action },
          {
            header: 'Target',
            cell: a =>
              a.target_type != null
                ? `${a.target_type} ${a.target_id ?? ''}`.trim()
                : '—',
          },
          {
            header: 'Actor',
            cell: a => {
              const name = [clean(a.actor?.first_name), clean(a.actor?.last_name)]
                .filter(Boolean)
                .join(' ');
              const email = clean(a.actor?.email);
              const fallback = a.actor_uid != null ? `uid ${a.actor_uid}` : '—';
              return (
                <div>
                  <div className="text-sm text-gray-900">{name || fallback}</div>
                  {email && <div className="text-xs text-gray-500">{email}</div>}
                </div>
              );
            },
          },
          {
            header: 'Outcome',
            cell: a => a.outcome ?? '—',
          },
        ]}
      />
    </div>
  );
};

export default AuditTab;
